import React, { FC } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import financePriceDisplayMultiStyles from './financePriceDisplayMultiStyles';
import Price from '../../../../../../gqlCommon/components/presentation/Price';
import InformativeSectionContainer from '../../../../customiseContainer/footer/PriceSection/informativeSection/InformativeSectionContainer';
import IndicativeNumber from '../../../../../../common/components/indicativeNumber/IndicativeNumber';
import CalculateButton from '../../../financeElements/calculateButton/CalculateButton';
import Translation from '../../../../../../common/components/translation/Translation';
import { PriceDisplayType } from '../../../../../../../../common/enum/PriceDisplayType';
import { IPaymentValue } from '../../../../../../gqlCommon/model/IPaymentValue';

export interface IFinancePriceDisplayMultiProps {
  primaryPrice: IPaymentValue;
  secondaryPrice: IPaymentValue;
  isDisabled?: boolean;
  onIndicativeClick: () => void;
  onFinanceCalculate: () => void;
}

const FinancePriceDisplayMulti: FC<IFinancePriceDisplayMultiProps> = ({
  primaryPrice,
  secondaryPrice,
  isDisabled,
  onIndicativeClick,
  onFinanceCalculate,
}) => {
  const {
    financePriceContainer,
    financePrice,
    priceContainer,
    multiCurrencyPriceContainer,
    priceGroup,
    orLabel,
    priceLabel,
    informativeSection,
    cta,
  } = financePriceDisplayMultiStyles();

  return (
    <Box className={financePriceContainer} data-test="container:finance-multicurrency">
      <Box className={informativeSection}>
        <InformativeSectionContainer />
      </Box>
      <Box
        className={clsx([priceContainer, multiCurrencyPriceContainer])}
        data-test={'finance_values:price:payment_value'}
      >
        <Box className={priceGroup}>
          <Price
            component="span"
            className={financePrice}
            price={primaryPrice?.amount}
            priceDisplayType={PriceDisplayType.PRIMARY_OPTIONS}
            data-test="text:price:total"
          />
          <Typography data-test="text:price:or" className={orLabel}>
            <Translation id="trans__configurator__price_display__text_between_prices" />
          </Typography>
          <Price
            component="span"
            className={financePrice}
            price={secondaryPrice?.amount}
            currency={secondaryPrice?.currency}
            data-test="text:price:secondary-finance-price-value"
            priceDisplayType={PriceDisplayType.SECONDARY_OPTIONS}
          />
        </Box>
        <Typography className={priceLabel} variant={'helpingText'} data-test={'text:price:label'}>
          <Translation id={'trans__configurator__customise_page_finance_details__repayment_label'} />
          <IndicativeNumber
            dataTest="repayment"
            displayNumber={<Translation id="trans__configurator__indicative_numbers__repayment" />}
            onClick={onIndicativeClick}
          />
        </Typography>
      </Box>
      <Box className={cta}>
        <CalculateButton disabled={isDisabled} onFinanceCalculate={onFinanceCalculate} />
      </Box>
    </Box>
  );
};

export default FinancePriceDisplayMulti;
